import { saveObject, saveObjectMetaData } from '../../../components/menu/SaveLoad';
import { setAdvance } from '../../../store/slices/AdvanceSlice';
import { setInitialized, setMenu, setSettings, TSettings } from '../../../store/slices/menuSlice';
import { store } from '../../../store/store';
import { isMobile } from '../platformCheck';
import { AppManagementInterface } from './appManagementInterface';

export interface ResolutionSettings {
    fullscreen: boolean,
}
interface AppManagementInterfaceDesktop extends AppManagementInterface {
    onChangeResolution: (options: ResolutionSettings) => void,
    onEscape: () => void,
}

const AppManagement: AppManagementInterfaceDesktop = {
    loadAndSetPersistentFile() {
        global.electronAPI?.getPersistent().then(persistent => {
            if (persistent) {

                store.dispatch(setAdvance({ seenWords: persistent.seenWords, globalSeenScenarios: (persistent.globalSeenScenarios || []), globalSeenImages: (persistent.globalSeenImages || []), canAdvance: false }));
                store.dispatch(setMenu({ settings: { ...persistent.settings, initialized: true }, gallery: (persistent.gallery || {}) }));

                onChangeResolution({ fullscreen: !!persistent.settings.fullscreen });

            } else {
                onSetSettings().then(res => {
                    store.dispatch(setInitialized(true));
                });

            }
        });

    },
    onExitGame() {
        global.electronAPI?.closeApp();
    },
    onMenuClosed() {
        if (isMobile()) {
        } else {
            // global.electronAPI.savePersistent().then(persistent => {
            // });
        }
    },
    async onSetSettings() {
        const { settings } = store.getState().menu;
        const { seenWords } = store.getState().advance;
        const persistent = await global.electronAPI?.getPersistent()!;

        return global.electronAPI?.setPersistent({ ...persistent, settings });
    },
    onPatreonPressed() {

        if (global.electronAPI) {
            global.electronAPI?.openLink("https://www.patreon.com/TTrickGames");
        }
        else {
            window.open("https://www.patreon.com/TTrickGames", "_blank", "noreferrer");
        }
    },
    onDiscordPressed() {
        if (global.electronAPI) {
            global.electronAPI?.openLink("https://discord.gg/3nVGBeaM3r");
        }
        else {
            window.open("https://discord.gg/3nVGBeaM3r", "_blank", "noreferrer");
        }

    },
    onSteamPressed() {
        if (global.electronAPI) {
            global.electronAPI?.openLink("https://store.steampowered.com/app/2538370/Long_Story_Short/");
        }
        else {
            window.open("https://store.steampowered.com/app/2538370/Long_Story_Short/", "_blank", "noreferrer");
        }

    },
    async onTakeScreenShot() {
        const res = await global.electronAPI?.takeScreenShot();
        if (res) {

            global.toast?.show(`Screenshot saved to ${res}`);
        } else {
            global.toast?.show("Failed saving screenshot...");

        }

    },
    async onDeleteSave(file: saveObjectMetaData): Promise<boolean | undefined> {
        return global.electronAPI?.deleteSave(file);

    },
    async onGetPickerOptions(): Promise<string[] | undefined> {
        return global.electronAPI?.getPickerOptions();

    },
    async onSaveFile(file: saveObject | saveObjectMetaData): Promise<saveObject> {

        return new Promise(async (res, rej) => {
            global.electronAPI?.save(file).then(obj => {
                res(obj);


            });
        });


    },
    async onGetFiles(settings: TSettings): Promise<Map<string, saveObjectMetaData>> {
        return new Promise(async (res, rej) => {
            if (global.electronAPI) {
                global.electronAPI.getFiles(settings).then(obj => {
                    if (!obj) {
                        res(new Map());
                    }
                    res(obj);
                });
            } else {

                res(new Map());
            }
        });

    },

    async onEscape() {
        if (isMobile()) {
        } else {
        }

    },
    async onChangeResolution(options: ResolutionSettings) {
        global.electronAPI?.changeResolution({ ...options });
        store.dispatch(setSettings({ fullscreen: options.fullscreen, windowed: !options.fullscreen }));

    },
    async onGetAllSaves(value?: string): Promise<Map<string, Map<string, saveObjectMetaData>>> {
        return new Promise(async (res, rej) => {
            if (global.electronAPI) {
                global.electronAPI.getAllFiles(value).then(obj => {
                    if (!obj) {
                        res(new Map());
                    }
                    res(obj);
                });
            }
        });
    },
    async onLoad(load: saveObjectMetaData): Promise<saveObject | null> {
        if (!global.electronAPI) { return Promise.resolve(null); }
        return global.electronAPI.getLoadFile(load);
    },
    async onCreatePickerFolder(folder: string): Promise<boolean> {
        return new Promise(async (response, rej) => {
            if (global.electronAPI) {
                global.electronAPI.createPickerFolder(folder).then(res => {
                    response(res);
                });
            }
        });

    },
    onDeletePickerFolder: function (folder: string): Promise<boolean> {
        return new Promise(async (response, rej) => {
            if (global.electronAPI) {
                global.electronAPI.deletePickerFolder(folder).then(res => {
                    response(res);
                });
            }
        });
    },
    onSaveGallery: async function () {
        const menuSlice = store.getState().menu;
        const { seenWords } = store.getState().advance;
        const persistent = await global.electronAPI?.getPersistent()!;

        global.electronAPI?.setPersistent(JSON.parse(JSON.stringify({ ...persistent, ...menuSlice })));
    }
};


export const {
    onSaveFile,
    onDeleteSave,
    onGetFiles,
    loadAndSetPersistentFile,
    onChangeResolution,
    onDiscordPressed,
    onSteamPressed,
    onEscape,
    onExitGame,
    onMenuClosed,
    onPatreonPressed,
    onSetSettings,
    onTakeScreenShot,
    onGetAllSaves,
    onLoad,
    onGetPickerOptions,
    onCreatePickerFolder,
    onDeletePickerFolder,
    onSaveGallery
} = AppManagement;